/* eslint-disable react/prop-types */
import * as React from 'react';
import { Button, Container } from '@mui/material';
import MaterialTable from 'material-table';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { findStripePayments } from '../api/venue-transactions-actions';
import { convertCentsToDollars, parseTimestamp } from './utils';

const headerStyle = {
  color: 'black',
  fontSize: '16px',
  fontWeight: 'bold',
};

export default function Payments({ userOwner }) {
  const [list, setList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const { eventId } = useParams();

  const getList = async (eventIdParam) => {
    setLoading(true);
    const response = await findStripePayments(eventIdParam);
    if (response?.data) setList(response?.data);
    setLoading(false);
  };

  useEffect(() => {
    getList(eventId);
  }, [eventId]);

  const stripeAccountId = userOwner?.stripe_details?.stripe_account_id;

  const listTable = list.map((item) => ({
    amount: convertCentsToDollars(item.amount),
    currency: item.currency,
    status: item.status,
    description: item.description,
    date: parseTimestamp(item.created),
    actions: (
      <div>
        <Button
          target="_blank"
          href={`https://dashboard.stripe.com/connect/accounts/${stripeAccountId}/payments`}
          variant="contained"
          disabled={!stripeAccountId}>
          View in Stripe
        </Button>
      </div>
    ),
  }));

  const totalAmount = list.reduce((acc, item) => acc + item.amount, 0);

  return (
    <Container>
      <div>
        <h3>Total Amount: {convertCentsToDollars(totalAmount)}</h3>
      </div>
      <MaterialTable
        isLoading={loading}
        title="Payments"
        columns={[
          { title: 'Amount', field: 'amount', headerStyle },
          { title: 'Currency', field: 'currency', headerStyle },
          { title: 'Status', field: 'status', headerStyle },
          { title: 'Description', field: 'description', headerStyle },
          { title: 'Date', field: 'date', headerStyle },
          {
            title: 'Actions',
            field: 'actions',
            headerStyle,
          },
        ]}
        data={listTable}
        options={{
          pageSize: 10,
          pageSizeOptions: [10, 20, 50],
        }}
      />
    </Container>
  );
}
